import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PATH_SUBSCRIPTION } from '../const';

const useChatWidgetScript = (isEnabled: boolean, widgetId: string, whatsappPhone: string) => {
  const history = useHistory();
  const isSubscriptionPage = history.location.pathname.includes(PATH_SUBSCRIPTION);

  const removeOmniWidgetScript = () => {
    const currentScript = document.querySelector('script[src*="omni-widget"]');
    if (currentScript && currentScript.parentNode) {
      currentScript.parentNode.removeChild(currentScript);
      document.querySelectorAll('#wt-omni-widget').forEach((el) => el.remove());
    }
  };
  const createAndAppendScript = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
        (function(w,d){
          const script = document.createElement('script');
script.src = 'https://webitel.lendplus.in/omni-widget/WtOmniWidget.umd.js';
script.onload = function () {
const body = document.querySelector('body');
const widgetEl = document.createElement('div');
widgetEl.setAttribute('id', 'wt-omnichannel-widget');
body.appendChild(widgetEl);
const config = {
"view":

{ "borderRadiusStyle": "rounded", "lang": "en", "btnOpacity": "1", "logoUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRn-0aYUgXlnsDEHoHltbsHzZgwS-9mv5nDTa0T6t7uANRYKPiqCq1wrEY&s=10", "accentColor": "hsl(46, 100%, 50%)" }
,
"chat":

{ "url": "wss://webitel.lendplus.in/chat/${widgetId}" }
,
"alternativeChannels":

{ "whatsapp": "https://wa.me/+${whatsappPhone}" }
};
const app = new WtOmniWidget('#wt-omnichannel-widget', config);
};
document.head.appendChild(script);
const link = document.createElement('link');
link.href = 'https://webitel.lendplus.in/omni-widget/WtOmniWidget.css';
link.type = 'text/css';
link.rel = 'stylesheet';
link.media = 'screen,print';
document.head.appendChild(link);
        })(window, document);
      `;

    !isSubscriptionPage && isEnabled && document.body.appendChild(script);
  };

  useEffect(() => {
    removeOmniWidgetScript();
    createAndAppendScript();

    return () => {
      removeOmniWidgetScript();
    };
  }, [widgetId, whatsappPhone]);
};

export default useChatWidgetScript;
